import { render, staticRenderFns } from "./StorageManager.vue?vue&type=template&id=52a0bda6&scoped=true"
import script from "./StorageManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./StorageManager.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StorageManager.vue?vue&type=style&index=0&id=52a0bda6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a0bda6",
  null
  
)

export default component.exports